import { getCurrentInstance } from '@vue/composition-api';
import { Issue } from '../dataType';

export const useIssue = () => {
  const instance = getCurrentInstance();
  const eventBus = instance ? (<any>instance.proxy).eventBus : undefined;
  return {
    openIssue: (id: number | Issue) => {
      if (!eventBus) {
        return;
      }
      const issueId = typeof id === 'number' ? id : (id.parentId || id.id);
      eventBus.$emit('issue:edit', { id: issueId });
    }
  };
};
